import { SelectUserProfileRequest } from 'angular-api-gateway/v1/model/selectUserProfileRequest';
import { SelectProfileRequestParams } from '@lentau/profile/shared/interfaces/profile-common-info';

export const getParams: (params: SelectProfileRequestParams) => SelectUserProfileRequest = (
  params: SelectProfileRequestParams
): SelectUserProfileRequest => {
  const requestParams: SelectUserProfileRequest = {};

  if (params?.legalEntityId) {
    requestParams.LegalEntityId = params.legalEntityId;
  }

  return requestParams;
};
